export const productTabs = [
  { label: "Details", value: "details" },
  // { label: "OEM", value: "oem" },
  // { label: "Benefits", value: "benefits" },
  // { label: "OEM Benefits", value: "oem-benefits" },
];

export const productEditTabs = [
  { label: "Details", value: "details" },
  { label: "OEM", value: "oem" },
  { label: "Benefits", value: "benefits" },
  { label: "OEM Benefits", value: "oem-benefits" },
];
